import { ContentDetailType } from "@authory-packages/core";

export const getImportInProgressTitle = (isPrivateView: boolean, contentDetailType: ContentDetailType) => {
    if (!isPrivateView) return "Page creation in progress";
    if (contentDetailType === ContentDetailType.CustomAudio) return "Audio is being processed";
    if (contentDetailType === ContentDetailType.CustomVideo) return "Video is being processed";
    return "Backup creation in progress";
};

export const getImportInProgressDescription = (isPrivateView: boolean, contentDetailType: ContentDetailType) => {
    if (!isPrivateView) return "The content for this page is currently being imported. This will usually take around 30 seconds.";
    if (contentDetailType === ContentDetailType.CustomAudio) return "We’re converting your audio now. It will appear here in a few seconds.";
    if (contentDetailType === ContentDetailType.CustomVideo) return "We’re converting your video now. It will appear here in a few seconds.";
    return "A copy of the original article is currently being created. This will usually take around 30 seconds.";
};
